import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTheme } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

interface ButtonsType {
            
      name: string,
      type? :'button' | 'submit' | 'reset',
      color: 'inherit' | 'primary' | 'secondary' | 'default' | undefined,
      clickFunc: ()=>void
      isLoading?:boolean,
      varient: 'contained'|'outlined'|'text',
    
    
}
interface AnnoucementTemplateType {
  title:string,
  description?:string,
  buttons:ButtonsType[],
  open:boolean,
  children: React.ReactNode;
}
export const AnnoucementTemplate:React.FC<AnnoucementTemplateType> = ({title, description,children, buttons,open}) =>{

  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  return (
    <div>
      <Dialog
        // fullScreen={fullScreen}
        open={open}
   
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        {description&& (
          <DialogContent>
            <DialogContentText>{description}</DialogContentText>
            
          </DialogContent>
        )}

        {children &&(
          <DialogContent>
            {children}
          </DialogContent>
        )}
       
        <DialogActions>
          {buttons&& buttons.map((x,idx) => (
            <Button disabled={x.isLoading} onClick={x.clickFunc} color={x.color} variant={x.varient} key={idx} type={x.type}>
              {x.name}
              {x.isLoading&& <CircularProgress size={16} style={{ marginLeft:8,color: 'white' }}/>}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </div>
  );
};


export default AnnoucementTemplate;